module.exports = __webpack_public_path__ + "static/media/wiip-icons.5c84c1b8.woff";